import {UyapRequest} from "./UyapRequest";
import {ResponseType} from "axios";

export class MakbuzIndirTalep {
    uyapId!: number;
    harcMiMasrafMi: string = "";
    uyapIslemTur!: string;
}

export default class MakbuzIndir extends UyapRequest<MakbuzIndirTalep, Blob> {
    getMethod(): "POST" | "GET" {
        return 'GET';
    }

    getSpinnerMessage(){
        return "Makbuz indiriliyor...";
    }

    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getMockResponse(): Blob {
        return new Blob([], {});
    }

    getResponseType(): ResponseType {
        return 'blob';
    }

    //OdemeIslemlerim.makbuzIndir(395606894,'',16);
    getUrl(): string {
        return this.ImzaClientAddr + 'odeme_makbuz_indir.uyap';//?uyapId='+this.uyapId+'&harcMiMasrafMi=&uyapIslemTur='+this.uyapIslemTur;
    }

    async parse(data: any): Promise<Blob> {
        //@ts-ignore
        if (!data.name) {
            //@ts-ignore
            data.name = "hata.html";
        }
        return data;
    }
}
